import { Box, Image } from '@mantine/core';
import classes from './Loading.module.css';
import InukLogo from '@assets/images/INUK-LOADER.gif';

export const Loading = () => {
	return (
		<Box className={classes.container}>
			<Image className={classes.loader} src={InukLogo} />
		</Box>
	);
};
